import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import {
  IComplaintsDashboardTrendView,
  IDashboardTrendMonth,
} from '../../../../../core/interfaces/complaints-dashboard.interface';
import { ComplaintsDashboardStore } from '../../complaints-dashboard.store';

@Component({
  selector: 'app-dashboard-trend-chart',
  templateUrl: './dashboard-trend-chart.component.html',
  styleUrls: ['./dashboard-trend-chart.component.scss'],
})
export class DashboardTrendChartComponent implements OnInit, OnDestroy {
  trend: IComplaintsDashboardTrendView;
  loading = false;
  failed = false;
  private subscriptions: Subscription[] = [];

  constructor(private store: ComplaintsDashboardStore) {}

  ngOnInit() {
    this.watchTrend();
    this.watchTrendLoading();
    this.watchTrendFailed();
  }

  trackByLabel(index: number, item: IDashboardTrendMonth) {
    return item.label;
  }

  private watchTrend() {
    this.subscriptions.push(
      this.store.trend$.subscribe({
        next: (trend: IComplaintsDashboardTrendView) => (this.trend = trend),
      }),
    );
  }

  private watchTrendLoading() {
    this.subscriptions.push(
      this.store.trendLoading$.subscribe({
        next: (loading: boolean) => (this.loading = loading),
      }),
    );
  }

  private watchTrendFailed() {
    this.subscriptions.push(
      this.store.trendFailed$.subscribe({
        next: (failed: boolean) => (this.failed = failed),
      }),
    );
  }

  get showError(): boolean {
    return !this.loading && this.failed;
  }

  get showChart(): boolean {
    return !this.loading && !!this.trend;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints-dashboard/components/dashboard-trend-chart/dashboard-trend-chart.component.ts